<template>
  <article class="dealer-item-parts">
    <a :href="shopData.link">
      <h5
        class="dealer-item-parts__name"
        v-text="shopData.name"
      />
      <p>
        {{ `〒${shopData.zipcode} ${shopData.address}` }}<br>
        {{ `営業時間: ${convertTime(shopData.open)}〜${convertTime(shopData.end)}` }}<br>
        {{ `TEL: ${shopData.tel} / FAX：${shopData.fax}` }}<br>
        店舗まで約 {{ shopData.distance }} km
      </p>
      <img
        class="dealer-item-parts__arrow"
        src="/wp-content/themes/HDJ2023_v1/assets/img/common/icon-arrow-right.svg"
        alt=""
      >
    </a>
  </article>
</template>

<script>
import {defineComponent, computed} from 'vue'

export default defineComponent({
  name: 'DealerItemParts',
  components: {},
  props: {
    shop: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const shopData = computed(() => props.shop)
    /**
     * hh:mm:ss からhh:mm に変換する
     */
    const convertTime = (time) => {
      const timeArr = time.split(':')
      return `${timeArr[0]}:${timeArr[1]}`
    }
    return {
      shopData,
      convertTime
    }
  },
})

</script>